import { translate } from './core/tools/translate';
import { notify, NOTIFY_TYPE } from './shared/notify';

const api = () => require('./api/index').default;

$(document).ready(() => {
    // ------------------------------------------------------------------------------
    // PASSWORD VALIDATION
    // ------------------------------------------------------------------------------
    function showErrorMessage (message: string): void {
        notify(NOTIFY_TYPE.ERROR, message);
    }

    function validatePassword (data: any): boolean {
        if (!data.Password || !data.ConfirmPassword) return false;

        var errors = [];

        if (data.Password !== data.ConfirmPassword) {
            showErrorMessage(translate('Error.LoginError.PasswordMatch'));
            return false;
        }

        if (data.Password.length < 6) errors.push(translate('Error.LoginError.MinimumLength'));
        if (data.Password.search(/[A-Z]/) === -1) errors.push(translate('Error.LoginError.Uppercase'));
        if (data.Password.search(/[a-z]/) === -1) errors.push(translate('Error.LoginError.Lowercase'));
        if (data.Password.search(/[0-9]/) === -1) errors.push(translate('Error.LoginError.Number'));
        if (data.Password.search(/[^0-9A-Za-z]/) === -1) errors.push(translate('Error.LoginError.SpecialCharacter'));

        if (errors.length) {
            showErrorMessage(translate('Error.LoginError.MessageIntro') + '<br />' + errors.join('<br />'));
            return false;
        }

        return true;
    }

    // ------------------------------------------------------------------------------
    // LOGIN
    // ------------------------------------------------------------------------------

    $('#form-signin').on('submit', e => {
        e.preventDefault();
        e.stopPropagation();
        const data = $(e.target).serializeObject();
        api().users.signIn(data.username.trim(), data.password.trim()).then(() =>
            setTimeout(() => location.reload(), 100)
        );
    });

    $('#user-signout').on('click', e => {
        e.preventDefault();
        e.stopPropagation();
        api().users.signOut();
    });

    const _showPasswordHint = () =>
        $('[data-toggle="popover"]').popover({
            content: `
        strong>A senha deve conter:</strong>
        <ul>
          <li>Ao menos 8 (oito) caracteres;</li>
          <li>Ao menos 1 (uma) letra mai&uacute;scula;</li>
          <li>Ao menos 1 (uma) letra min&uacute;scula;</li>
          <li>Ao menos 1 (um) n&uacute;mero;</li>
          <li>Ao menos 1 (um) caracter especial (@, #, $, etc).</li>
        </ul>
      `
        });

    // ------------------------------------------------------------------------------
    // CHANGE PASSWORD
    // ------------------------------------------------------------------------------

    $('#change-password').on('click', e => {
        e.stopPropagation();
        $('#form-change-pass').trigger('reset');
        $('.change-password-container').show();
        $('#sidebar-container').hide();
        _showPasswordHint();
    });

    $('#form-change-pass').on('reset', () => {
        $('.change-password-container').hide();
        $('#sidebar-container').show();
    });

    $('#form-change-pass').on('submit', e => {
        e.preventDefault();
        e.stopPropagation();

        const data = $(e.target).serializeObject();

        if (!validatePassword(data)) return;

        data.UserName = sessionStorage.username;

        api().management.update.user.password(data).then((data) => {
            // SUCCESS
            $('.change-password-container').hide();
            $('#sidebar-container').show();
        }, (e) => {
            // ERROR
            showErrorMessage(translate('Error.LoginError.IncorrectPassword'));
        });
    });

    // ------------------------------------------------------------------------------
    // NEW PASSWORD WITH TOKEN
    // ------------------------------------------------------------------------------

    $('#form-reset-token').on('reset', (e) => {
        e.preventDefault();

        $('#form-need-help input:radio').removeAttr('checked');

        $('.reset-token-container').hide();
        $('.need-help-container').show();
    });

    $('#form-reset-token').on('submit', e => {
        e.preventDefault();
        e.stopPropagation();

        const data = $(e.target).serializeObject();

        if (!validatePassword(data)) return;

        api().management.update.user.password.token(data).then((data) => {
            // SUCCESS
            $(e.target).find(':input').val('');
            $('.reset-token-container').hide();
            $('.need-help-container').hide();
            $('.login-container').show();
        }, (e) => {
            // ERROR
            showErrorMessage(translate('Error.LoginError.IncorrectToken'));
        });
    });

    // ------------------------------------------------------------------------------
    // SEND EMAIL RESET
    // ------------------------------------------------------------------------------

    $('#form-reset-pass').on('reset', e => {
        e.preventDefault();

        $('#form-need-help input:radio').removeAttr('checked');

        $('.reset-pass-container').hide();
        $('.need-help-container').show();
    });

    $('#form-reset-pass').on('submit', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const data = $(e.target).serializeObject();

        $('.reset-pass-container').hide();
        $('.login-container').show();

        api().management.update.user.password.forgot(data);
    });

    // ------------------------------------------------------------------------------
    // NEED HELP?
    // ------------------------------------------------------------------------------

    $('#reset-pass-link').on('click', () => {
        $('.login-container').hide();
        $('.need-help-container').show();
        $('#form-need-help input:radio').removeAttr('checked');
    });

    $('#form-need-help').on('reset', (e) => {
        e.preventDefault();

        $(e.target).find(':input').val('');

        $('.need-help-container').hide();
        $('.login-container').show();
    });

    $('#form-need-help').on('submit', e => {
        e.preventDefault();
        e.stopPropagation();

        const data = $(e.target).serializeObject();

        $('#form-reset-pass :input').val('');
        $('#form-reset-token :input').val('');

        if (Number(data.help) === 1) {
            $('.need-help-container').hide();
            $('.reset-pass-container').show();
        } else {
            $('.need-help-container').hide();
            $('.reset-token-container').show();
            _showPasswordHint();
        }
    });
});



// WEBPACK FOOTER //
// ./src/scripts/login.js